"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUEST_FAILURE = exports.REQUEST_SUCCESS = exports.REQUEST_STARTED = void 0;
exports.REQUEST_STARTED = 'Actionify Request Started';
exports.REQUEST_SUCCESS = 'Actionify Request Success';
exports.REQUEST_FAILURE = 'Actionify Request Failure';
